export default "__VITE_ASSET__DzilDeMi__"